import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const AirplaneIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M18.64 2.04a3.86 3.86 0 0 1 2.8.07c.2.1.36.25.45.44.42.83.35 1.87.07 2.8-.3.98-.89 2-1.75 2.86l-3.12 3.11 1.69 7.67-.98.21.98-.2a2.14 2.14 0 0 1-1.1 2.33l-.5.2c-.84.33-1.86.2-2.48-.63a1.03 1.03 0 0 1-.03-.05l-2.95-4.46L10 17.54V20a1 1 0 0 1-.3.7l-1 1a1 1 0 0 1-1.53-.15l-1.9-2.83-2.82-1.89a1 1 0 0 1-.16-1.54l1-1A1 1 0 0 1 4 14h2.46l1.15-1.72-4.46-2.95a1.06 1.06 0 0 1-.05-.03c-.83-.62-.96-1.64-.63-2.47a1 1 0 0 1 .07-.14l.29-.48a1.95 1.95 0 0 1 2.17-1l.01.01 7.67 1.69 3.11-3.12a7.02 7.02 0 0 1 2.85-1.75ZM16.82 19.4l-1.8-8.19a1 1 0 0 1 .27-.92l3.5-3.5a5.03 5.03 0 0 0 1.25-2.02c.13-.4.16-.72.14-.95-.23-.02-.55.01-.95.14-.65.2-1.39.61-2.02 1.25l-3.5 3.5a1 1 0 0 1-.92.27l-8.2-1.8h-.01l-.02.03-.25.42-.01.07 5.25 3.47a1 1 0 0 1 .28 1.38l-2 3A1 1 0 0 1 7 16H4.8l1.75 1.17a1 1 0 0 1 .28.28L8 19.2V17a1 1 0 0 1 .45-.83l3-2a1 1 0 0 1 1.38.28l3.47 5.25c.02 0 .06 0 .13-.03l.35-.14a.21.21 0 0 0 .04-.06v-.07Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default AirplaneIcon;
